var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-preview-field mb-4"},[_c('v-btn',{staticClass:"white--text mb-2",attrs:{"large":"","depressed":"","color":"blue darken-2"},on:{"click":function($event){return _vm.setDialogInvoicePayment(true)}}},[_vm._v(_vm._s(_vm._f("mq")(_vm.$mq,{ xs: 'Open Payments', sm: 'Show Payments Popup' })))]),_c('DialogInvoicePayment',{attrs:{"order":{
      id: 'Preview Test Order',
      fields: {
        'Order #': 421,
        'Total Cost': Number(_vm.total),
      },
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }